import { render, staticRenderFns } from "./organizers.vue?vue&type=template&id=3842e728"
import script from "./organizers.vue?vue&type=script&lang=js"
export * from "./organizers.vue?vue&type=script&lang=js"
import style0 from "./organizers.vue?vue&type=style&index=0&id=3842e728&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports